export const LOCKER_EDIT_LOG_FIELDS = [
  { field_id: 'academic_year', label: 'Academic Year' },
  { field_id: 'year_group', label: 'Year Group' },
  { field_id: 'block', label: 'Block' },
  { field_id: 'locker_number', label: 'Locker Number' },
  { field_id: 'locker_added_to_maintenance', label: 'Locker added to maintenance' },
  { field_id: 'first_name', label: 'First Name' },
  { field_id: 'surname', label: 'Surname' },
  { field_id: 'payment_amount', label: 'Payment amount' },
  { field_id: 'payment_link_sent', label: 'Payment link sent' },
]

export const asLogRows = (data) => {
  if (!data) return []
  return Array.isArray(data) ? data.filter(Boolean) : [data]
}

export const normalizeLockerEditRow = (row = {}) => {
  const answers = row.questions_and_answers || {}
  return {
    ...row,
    academic_year: row.academic_year || row.item_date_time_id_label || '',
    year_group: row.year_group || row.category_id_label || '',
    block: row.block || row.location_id_label || '',
    locker_number: row.locker_number || row.item_id_label || '',
    locker_added_to_maintenance: row.locker_added_to_maintenance || 'no',
    first_name: row.first_name || row.student_name || answers.student_name || '',
    surname: row.surname || row.student_surname || answers.student_surname || '',
    payment_amount: row.payment_amount || '',
    payment_link_sent: row.payment_link_sent || 'no',
  }
}

export const isLockerEditLog = (rows) => asLogRows(rows).some((row) => row?.log_action === 'edit_locker')

export const lockerEditHeadline = (rows) => {
  const first = normalizeLockerEditRow(asLogRows(rows)[0] || {})
  const locker = first.locker_number || ''
  const block = first.block || ''
  if (!locker && !block) {
    return ' has edited the locker'
  }
  if (!block) {
    return ` has edited locker ${locker}`
  }
  return ` has edited locker ${locker} in ${block}`
}
